import { getFilterConfig } from '../../../utils/filter';
import { FILTER } from '../../../data/enums/filter';

const filter = getFilterConfig([FILTER.CHANNEL, FILTER.CATEGORY, FILTER.SUB_D, FILTER.SKU, FILTER.BRAND, FILTER.DSE]);

export { filter as filterConfig };
